import { Component, OnInit } from '@angular/core';
import { SharedService } from '../../services/shared.service';

@Component({
  selector: 'app-solvo-it',
  templateUrl: './solvo-it.component.html',
  styleUrls: ['./solvo-it.component.css']
})
export class SolvoItComponent implements OnInit {

  constructor(private sharedService: SharedService) { }

  ngOnInit() {
    this.sharedService.reloadUserPrivileges();
  }

}
